module.exports = __webpack_public_path__ + "static/media/55.e4b2fb7f.jpg";